// import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/produce-crafts',
    name: 'PUT_PRODUCE_CRAFT',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
